import * as React from 'react';
import { List } from '../list';
import { Progress } from '../progress';
import styled from '../../styles/styled-components';

interface FileDownloadsProps {
  downloads: Record<string, { name: string; percent: number }>;
}

export const FileDownloads: React.SFC<FileDownloadsProps> = ({
  downloads,
  ...rest
}) => (
  <div>
    <h5 style={{ marginTop: 0, marginBottom: 0 }}>Downloading...</h5>
    <List
      {...rest}
      items={Object.keys(downloads)
        .map(key => ({ key, file: downloads[key] }))
        .filter(({ file }) => file.percent < 1)
        .map(({ key, file }) => ({
          key,
          header: file.name,
          description: <FixedWidthProgress progress={file.percent * 100} />,
        }))}
    />
  </div>
);

export const areDownloadingFilesInProgress = (
  downloads: FileDownloadsProps['downloads'],
) =>
  Object.keys(downloads).filter(key => downloads[key].percent < 1).length !== 0;

const FixedWidthProgress = styled(Progress)`
  width: 200px;
`;
